import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./css/PdfContent.css"

const IntroductionSpeechView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { uuid, day, content, returnUrl, type } = location.state || {};
    const generatePDF = () => {
    const element = document.getElementById("pdf-content");
    if (!element) return;

    window.scrollTo(0, 0);

    const options = {
      margin: 0,                    // ✅ Set to 0 — padding is handled inside #pdf-content
      filename: `IntroductionSpeech_${uuid || "uuid"}_${day || "day"}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollY: -window.scrollY,   // ✅ Fix vertical offset
        windowWidth: 794,           // ✅ Match A4 width exactly
        backgroundColor: "#ffffff",
        logging: false,
      },
      jsPDF: {
        unit: "px",                 // ✅ Use px to match screen dimensions
        format: [794, 1123],        // ✅ Explicit A4 in px
        orientation: "portrait",
      },
      pagebreak: {
        mode: ["css", "legacy"],
        before: ".page-break-before",
        avoid: ["p", "li", "h1", "h2", "h3", "table", "img"],
      },
    };

    html2pdf()
      .set(options)
      .from(element)
      .save()
      .then(() => {
        Swal.fire({
          title: "PDF Generated!",
          text: "What do you want to do next?",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Go to Introduction Speech",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/eventIntroductionSpeech", { state: { refetch: true } });
          }
        });
      });
  };
  const backbtn = () => {
    window.history.back();
  };

  return (
  <div className="container mt-4">
    <div className="text-end mb-2">
      <button className="btn btn-danger mt-3 mr-5" onClick={backbtn}>Back</button>
      &nbsp;&nbsp;
      <button className="btn btn-primary mt-3" onClick={generatePDF}>Export as PDF</button>
    </div>

    {/* ✅ Wrapper for screen display only — NOT captured in PDF */}
    <div style={{ display: "flex", justifyContent: "center" }}>

      {/* ✅ Only this div is captured */}
      <div
        id="pdf-content"
        className="ql-container ql-snow"
        style={{
          width: "794px",
          minHeight: "1123px",
          background: "#fff",
          padding: "40px 50px",   // balanced padding left/right
          boxSizing: "border-box",
          fontFamily: "Arial, sans-serif",
          fontSize: "16px",
          color: "#000",
        }}
      >
        <h3 style={{ marginBottom: "20px" }}>
          Introduction Speech - {day === "day_one" ? "Day 1" : "Day 2"}
        </h3>

        {/* ✅ ql-editor only on inner content, not the container */}
        <div
          className="ql-editor"
          style={{ padding: 0, border: "none", overflow: "visible" }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>

    </div>
  </div>
);
};

export default IntroductionSpeechView;
